'use strict';
'use es6';

// Babel does not support extending built-in's like Error or Array
// This follows MDNs guidance for creating custom errors.
//
// See: https://mdn.io/Global_Objects/Error#Custom_Error_Types

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPubNubError;
function createPubNubError(_ref) {
  var name = _ref.name,
      defaultMessage = _ref.defaultMessage;


  function PubNubError(message) {
    this.message = message || defaultMessage;
    this.stack = new Error().stack;
  }

  PubNubError.prototype = Object.create(Error.prototype);
  PubNubError.prototype.constructor = PubNubError;
  PubNubError.prototype.name = name;

  return PubNubError;
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/errors/createPubNubError.js
// module id = 460
// module chunks = 0